import words from "naughty-words"

const nameRegex = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,13}[a-zA-Z0-9]$/

let naughtyWordsSet: Set<string> | null = null

function getNaughtyWordsSet(): Set<string> {
  naughtyWordsSet ||= new Set([
    ...words.en,
    ...words.es,
    ...words.fr,
    ...words.de,
    ...words.it,
    ...words.pt,
    ...words.ru,
    ...words.tr,
    ...words.zh,
  ])
  return naughtyWordsSet
}
const reservedWords = new Set([
  "feedback",
  "help",
  "support",
  "contact",
  "faq",
  "about",
  "privacy",
  "terms",
  "tos",
  "eula",
  "cookie",
])

export function validateName(name: string | null | undefined) {
  if (!name) return false
  if (!name.length) return false

  return nameRegex.test(name)
}

export function validateReserved(name: string) {
  return !reservedWords.has(name)
}

export function validateNaughty(name: string) {
  return !getNaughtyWordsSet().has(name)
}
